let createArrayAtoZ = _ => {
    return Array 
       .apply(null, {length: 26}) 
       .map((x, i) => String.fromCharCode(65 + i)).concat('#');
}

let jumptoAnchor = anchor => {
    window.location.href = "#" + anchor;
}

let createNavigationList = _ => {
    const abcChars = createArrayAtoZ();
    const navigationEntries = abcChars.reduce(createDivForCharElement, ''); 
    jQuery('#nav').append(navigationEntries);

    const lettersActive = createArrayAtoZ();
    lettersActive.forEach(letter => { 
       changeItemState(letter); 
       //addListEntries(letter); 
    });
}

let changeItemState = character => {
    const characterElement = jQuery('#nav').find('.CharacterElement[data-filter="' + character + '"]');
    jQuery(characterElement).click(() => jumptoAnchor(character));
    characterElement.removeClass('Inactive');
}

let createDivForCharElement = (block, charToAdd) => { 
    return block + "<span id='CharacterElement' class='CharacterElement Inactive' data-filter='" + charToAdd + "'>" + charToAdd + "</span>"; 
}

let addListEntries = letter => {
    jQuery('#AppComponent').append("<div class='AppElement' id='" + letter + "'>" + letter + "</div>");
}

jQuery(document).ready(function() {
    createNavigationList();
});
function htmlDecode(input){
    var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  }



(function($) {
    var delay=100, timer;
    // if user hovers over boardgame name

    function maybe_do_ajax_call( _this, onComplete ) {

        if ( _this.hasClass('ajaxComplete') ) {
            return onComplete();
        }

        if ( _this.hasClass('ajaxProcessing') ) {
            setTimeout(() => { maybe_do_ajax_call(_this, onComplete)}, 100);
            return;
        }

        _this.addClass('ajaxProcessing');

        const gameId = _this.data('game-id');
        const locations = _this.data('locations');
        
        $.ajax({
            url: '/wp-content/themes/x-child/retrieve.php?id=' + gameId
        }).done(function(data) {
            // find raw description
            var description = $($.parseXML(data)).find('boardgames boardgame description').html();
            // split by paragraphs
            var parts = description.split('&lt;br/&gt;');
            description = parts[0];
            var i = 1;
            // keep adding paragraphs until there are none left or the text is more than or equal to 200 characters
            while (description.length < 200 && i < parts.length) {
                description +=  '&lt;br/&gt;' + parts[i];
                i += 1;
            }
            // find min and max players
            var min = $($.parseXML(data)).find('boardgames boardgame minplayers').html();
            var max = $($.parseXML(data)).find('boardgames boardgame maxplayers').html();
            // Find time age and designer
            var mintime = $($.parseXML(data)).find('boardgames boardgame minplaytime').html();
            var maxtime = $($.parseXML(data)).find('boardgames boardgame minplaytime').html();
            var age = $($.parseXML(data)).find('boardgames boardgame age').html();
            var designer = $($.parseXML(data)).find('boardgames boardgame boardgamedesigner').html();

            $('[data-game-id=' + gameId + ']').append('<div class="description"><div class="description--close"></div><p class="desc">' + htmlDecode(description) + '</p>' + '<p class="players"><span>Players: </span> ' + min + ' - ' + max 
            + '</p>' + '<p class="age"><span>Age: </span> ' + age + '</p>' + '<p class="playing_time"><span>Playing Time: </span> ' +  maxtime + ' minutes' + '</p>' + '<p class="designer"><span>Designer: </span> ' + designer + '</p>'
            + '<p class="locations"><span>Locations: </span>' + locations + '</p>' + '<p class="disclaimer">Boardgame information powered by BoardGameGeek' + '</p>');

            _this.children('p').addClass('none');
            _this.removeClass('ajaxProcessing');
            _this.addClass('ajaxComplete');

                
            onComplete();
        })
    }

    function go_to_open_state( _this ) {
        maybe_do_ajax_call(_this, () => {
            _this.children('.description').removeClass('none');
            //Close other descriptions
            _this.siblings('.open').children('.description').addClass('none');
            _this.siblings('.open').removeClass('open');
        })
        _this.addClass('open');
    }

    function go_to_closed_state( _this ) {
        _this.removeClass('open');
        _this.children('.description').addClass('none');
    }

    function toggle_state(_this) {
        if (_this.hasClass( 'open' )) {
            go_to_closed_state( _this )
        } else {
            go_to_open_state( _this )

        }
    }

    $('[data-game-id]').click(function() {
        toggle_state( $(this) ) 
    });

    $('#mobile-listings').change( function() {
        var target = $(this);
        if( target.length ) {
            window.location.href = "#" + target.context.value;
        }
    })
    
})(jQuery)



